import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { I13nButton } from 'react-i13n';
import { CSSTransitionGroup } from 'react-transition-group';

import PremiumRibbon from './PremiumRibbon';

export default class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlideIdx: 0
    };
  }

  onPrev = () => {
    const nextSlide =
      this.state.currentSlideIdx === 0
        ? this.props.slides.length - 1
        : this.state.currentSlideIdx - 1;

    this.setState({ currentSlideIdx: nextSlide });
    this.context.i13n.executeEvent('click', {
      label: `Previous Slide (from ${
        this.state.currentSlideIdx
      } to ${nextSlide})`
    });
  };

  onNext = () => {
    const nextSlide =
      this.state.currentSlideIdx === this.props.slides.length - 1
        ? 0
        : this.state.currentSlideIdx + 1;

    this.setState({ currentSlideIdx: nextSlide });
    this.context.i13n.executeEvent('click', {
      label: `Next Slide (from ${this.state.currentSlideIdx} to ${nextSlide})`
    });
  };

  render() {
    const { slides } = this.props;
    const { currentSlideIdx } = this.state;
    // slides is an array of stateless components
    const CurrentSlide = slides[currentSlideIdx];

    const mountedHiddenSlides = slides.map((Slide, i) => (
      <div key={i} className="h_d-n">
        <Slide />
      </div>
    ));

    const dots = slides.map((Slide, i) => (
      <li
        key={i}
        className={classNames('slider-dots__item', {
          active: currentSlideIdx === i
        })}
        onClick={() => this.setState({ currentSlideIdx: i })}
      >
        <I13nButton
          type="button"
          i13nModel={{ action: 'click', label: `Slider Dot ${i}` }}
          className="slider-dots__btn"
        />
      </li>
    ));

    return (
      <div className="slider">
        <PremiumRibbon
          actAsTooltip={true}
          hide={!this.props.isPremium}
          className="slider__premium-ribbon"
        />
        <CSSTransitionGroup
          transitionName="sliderFade"
          transitionEnterTimeout={400}
          transitionLeave={false}
        >
          <CurrentSlide key={currentSlideIdx} />
        </CSSTransitionGroup>
        {mountedHiddenSlides}
        <ul className="slider-dots">{dots}</ul>
        <div onClick={this.onPrev} className="arrow arrow__prev">
          <img src="/static/images/icons/ic_arrow-left.svg" />
        </div>
        <div onClick={this.onNext} className="arrow arrow__next">
          <img src="/static/images/icons/ic_arrow-right.svg" />
        </div>
      </div>
    );
  }
}

Slider.contextTypes = {
  i13n: PropTypes.object.isRequired
};
